// src/screens/Capture.js
import { compressImage, validateImageFile } from '../utils/imageUtils.js';
import { analyzeConcrete } from '../services/claude.js';

export function CaptureScreen(container, state, actions) {
  container.innerHTML = `
    <div class="screen">
      <div class="top-bar">
        <div class="logo">
          <div class="logo-sq"><i class="ti ti-building-factory-2" aria-hidden="true"></i></div>
          <div><div class="logo-name">CONCREPRO</div></div>
        </div>
        <div class="sponsor-badge"><i class="ti ti-star" aria-hidden="true" style="font-size:9px"></i> Sika</div>
      </div>
      <div class="screen-body">
        <button class="btn-back" id="btn-back">
          <i class="ti ti-arrow-left" aria-hidden="true"></i> Inicio
        </button>
        <h2 style="font-size:20px;font-weight:500;margin:0 0 4px">Capturar imagen</h2>
        <p style="font-size:13px;color:var(--dim);margin:0 0 14px">Fotografía el área dañada. Sin registro requerido.</p>

        ${state.error ? `<div class="error-box"><i class="ti ti-alert-triangle" aria-hidden="true"></i> ${state.error}</div>` : ''}

        ${!state.image
          ? `<div class="upload-zone" id="upload-zone">
               <input type="file" id="file-input" accept="image/*" capture="environment" aria-label="Seleccionar imagen de concreto">
               <i class="ti ti-camera-plus" style="font-size:36px;color:var(--muted)" aria-hidden="true"></i>
               <div style="font-size:14px;font-weight:500;margin:10px 0 4px">Toca para fotografiar</div>
               <div class="mono" style="font-size:11px;color:var(--muted)">JPEG / PNG · comprime automáticamente</div>
             </div>`
          : `<div style="border-radius:var(--r-lg);overflow:hidden;border:1px solid var(--border2);position:relative">
               <img src="${state.image.dataUrl}" alt="Vista previa del área a analizar" style="width:100%;max-height:260px;object-fit:cover;display:block">
               <button id="btn-change" aria-label="Cambiar imagen" style="position:absolute;top:8px;right:8px;background:rgba(0,0,0,.72);color:#fff;border:none;border-radius:6px;padding:4px 10px;font-size:12px;cursor:pointer;display:flex;align-items:center;gap:4px">
                 <i class="ti ti-refresh" aria-hidden="true" style="font-size:13px"></i> Cambiar
               </button>
             </div>
             <div class="tip-box">
               <i class="ti ti-lock" style="font-size:14px;flex-shrink:0;margin-top:1px" aria-hidden="true"></i>
               <span>Procesado localmente. <strong>No se almacena en ningún servidor.</strong> Imagen efímera.</span>
             </div>`}

        <button id="btn-analyze" class="btn-primary" style="margin-top:4px" ${!state.image ? 'disabled' : ''}>
          <i class="ti ti-microscope" aria-hidden="true"></i> Analizar con IA normativa
        </button>
      </div>
    </div>`;

  container.querySelector('#btn-back')?.addEventListener('click', () => {
    actions.navigate('home', { image: null, error: null, diagnosis: null });
  });

  container.querySelector('#btn-change')?.addEventListener('click', () => {
    actions.setState({ image: null, error: null });
  });

  const fileInput = container.querySelector('#file-input');
  fileInput?.addEventListener('change', async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const { valid, error } = validateImageFile(file);
    if (!valid) { actions.setState({ error }); return; }
    try {
      const c = await compressImage(file);
      actions.setState({ image: { base64: c.base64, dataUrl: c.dataUrl }, error: null });
    } catch {
      actions.setState({ error: 'No se pudo procesar la imagen.' });
    }
  });

  container.querySelector('#btn-analyze')?.addEventListener('click', async () => {
    if (!state.image) return;
    actions.navigate('analyzing', { loadMsgIndex: 0 });
    actions.startLoadingCycle(5);
    try {
      const diagnosis = await analyzeConcrete(state.image.base64, 'auto', '');
      actions.stopLoadingCycle();
      if (diagnosis.requires_additional_input) {
        actions.navigate('additional_input', { diagnosis });
      } else {
        actions.navigate('result', { diagnosis });
      }
    } catch (e) {
      actions.stopLoadingCycle();
      actions.navigate('capture', { error: 'Error al analizar: ' + (e.message || 'Intenta de nuevo.') });
    }
  });
}
